import ChaptersFilterContainer from './chapters_filter_container';

const ChaptersFilter = ChaptersFilterContainer;
export default ChaptersFilter;
